import * as React from 'react'
import {
  Pressable,
  PressableStateCallbackType,
  StyleSheet,
  Text,
  View,
} from 'react-native'
import Link from 'next/link'
import { Typemark, Icon as LogoIcon } from '@components/Branding'
import { Spacer } from '@components/Spacer'
import * as Colors from '@themes/Colors'

type ButtonProps = {
  title: string
  href: string
  isActive?: boolean

  alignRight?: boolean
}

export function NavLogoButton(
  props: ButtonProps = {
    title: 'Purposity',
    href: '/',
    isActive: false,

    alignRight: false,
  }
) {
  return (
    <Pressable
      style={[
        styles.buttonContainer,
        props.alignRight && { justifyContent: 'flex-end' },
      ]}
    >
      {({ pressed, hovered }) => (
        <ButtonView pressed={pressed} hovered={hovered} {...props} />
      )}
    </Pressable>
  )
}

function ButtonView(props: ButtonProps & PressableStateCallbackType) {
  return (
    <Link href={props.href} passHref>
      <View
        style={[
          styles.button,
          (props.hovered || props.pressed) && styles.hovered,
        ]}
      >
        <Spacer
          width={14}
          height={1}
          noShrink
          style={{ alignSelf: 'center' }}
        />

        <View style={styles.fdColumn}>
          <Spacer noShrink height={4} />
          <Text style={styles.icon}>
            <LogoIcon />
          </Text>
        </View>

        <Spacer noShrink width={20} />

        <View style={styles.fdColumn}>
          <Typemark title="Purposity" />
          <Spacer noShrink height={2} />
        </View>

        <Spacer
          width={20}
          height={1}
          noShrink
          style={{ alignSelf: 'center' }}
        />
      </View>
    </Link>
  )
}

const styles = StyleSheet.create({
  fdColumn: {
    flexDirection: 'column',
  },
  buttonContainer: {
    width: '100%',
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
  },
  button: {
    width: 'fit-content',
    height: 46,
    minWidth: 46,
    flexShrink: 0,
    flexGrow: 0,
    flexDirection: 'row',
    fontSize: 22,
    justifyContent: 'center',
    alignItems: 'center',
    color: Colors.alternateGray,
    backgroundColor: Colors.white,
    borderRadius: 23,
    userSelect: 'none',
  },

  hovered: {
    backgroundColor: Colors.altWhite,
  },

  pressed: {
    backgroundColor: Colors.blues[1],
  },
  icon: {
    lineHeight: 19,
    fontSize: 22,
  },
})
